import React, {useState, useEffect } from "react";

import { FormInput } from "./FormInput";

import { func_validation } from "functions";



/* Props 
 * {
 *      // Label
 *      isInputOptional: false,
 *      isLabelOptional: false,
 *      inputLabel: "", 
 *      inputSideLabel: "", 
 * 
 *      // Group
 *      isInputGrouped: false,
 *      inputPrepend: "" | JSX,
 *      inputAppend: "" | JSX, 
 * 
 *      // Side
 *      inputDisplayLeftSide: JSX, 
 *      inputDisplayRightSide: JSX, 
 *      isInputSideHiddenOnFocus: false, 
 * 
 *      // Input
 *      inputName: "",
 *      inputValue: "",
 * 
 *      // Input Options
 *      customInputType: "text",
 *      inputMaxLength: 524288 (default Max),
 *      inputRows: 2,
 *      inputPlaceholder: "",
 *      isInputDisabled: false, 
 * 
 *      // Input Handling
 *      isInputClickHandlingRequired: false,
 *      isInputFocusHandlingRequired: false,
 *      isInputKeyPressHandlingRequired: false,
 *      isInputBlurHandlingRequired: false,
 * 
 *      // Input Validation
 *      isInputValueTrim_onChange: false,
 *      isInputValueTrim_onBlur: false,
 * 
 *      // Custom Input Validation
 *      customValidator_onChange: (value_formatted)=>{ return value; },
 *      customValidator_onBlur: (value_formatted)=>{ return value; },
 *      isValuePropagationGuarded_onChange: (value_formatted)=>{ return true/false; },
 *      isValuePropagationGuarded_onBlur: (value_formatted)=>{ return true/false; },
 * 
 *      // Input Propagation
 *      inputStateName: undefined,
 *      propagateValueChange: (inputStateName, value_formatted)=>{},
 *      handleInputClickExtend: (e)=>{}, 
 *      handleInputFocusExtend: (e)=>{}, 
 *      handleInputKeyPressExtend: (e)=>{},
 *      handleInputChangeExtend: (value_formatted)=>{},
 *      handleInputBlurExtend: (value_formatted)=>{},
 * 
 *      // Error Display
 *      isErrorOptional: false,
 *      isFormSubmissionAttempted: false,
 * 
 *      // Error Checking
 *      customErrorMsgDefault: "",
 *      customErrorValidation: undefined,
 *      customErrorMsg: "",
 * 
 *      // Custom Error
 *      isInputHasError: false,
 *      customErrorDisplayArray: [{ isError: true|false, errorMsg: "" }],
 * 
 *      // Others
 *      className: "",
 *      customInputClassName: "",
 *      customComplexInputClassName: "",
 *      customPrependClassName: "",
 *      customAppendClassName: "",
 *      formInputCustomTheme: "component-formInputTheme_default",
 *      isMarginBtmOptional: false,
 *      inputCustomOptions: {},
 * }
 */

function FormInput_textareaPresentation(props) {
    const { className, wrapperClassname, customInputClassName, customComplexInputClassName, customPrependClassName, customAppendClassName, 
        formInputCustomTheme, isMarginBtmOptional, inputCustomOptions, 
        // Label
        isLabelOptional, inputLabel, inputSideLabel, isInputOptional, 
        // Group
        isInputGrouped, inputPrepend, inputAppend, 
        // Side
        inputDisplayLeftSide, inputDisplayRightSide, isInputSideHiddenOnFocus, 
        // Input
        inputValue: inputValue_props, inputName, inputValue_default, customInputType, 
        inputMaxLength, inputRows, inputPlaceholder, isInputDisabled, isResetRequired,
        // Input Handling
        isInputClickHandlingRequired, isInputFocusHandlingRequired, isInputKeyPressHandlingRequired, isInputBlurHandlingRequired, 
        // Error Checking
        isErrorOptional, isErrorMsgOptional,
        isFormSubmissionAttempted, 
        customErrorMsgDefault, customErrorValidation, customErrorMsg,
        isInputHasError, customErrorDisplayArray } = props;

    // States
    let inputValue_default_formatted = func_validation.isNotNullUndefined(inputValue_default)? inputValue_default: "";
    const [isDefaultInputValueSet, setIsDefaultInputValueSet] = useState(func_validation.isNotNullUndefined(inputValue_default_formatted));
    const [inputValue, setInputValue] = useState(inputValue_default_formatted);

    // Update States
    function updateInputValue() {
        if ((!isDefaultInputValueSet) &&
            func_validation.isNotNullUndefined(inputValue_default)) {

            setInputValue(inputValue_default);
            setIsDefaultInputValueSet(true);
        }

        if (func_validation.isNotNullUndefined(inputValue_props))
            setInputValue(inputValue_props);
    }
    useEffect(() => {
        updateInputValue();
    }, [inputValue_props, inputValue_default]);

    useEffect(() => {
        if (isResetRequired) setInputValue(inputValue_default_formatted);
    }, [isResetRequired]);

    function handleInputClick(e) {
        // Extension
        if (props.handleInputClickExtend) props.handleInputClickExtend(e);
    }

    function handleInputFocus(e) {
        // Extension
        if (props.handleInputFocusExtend) props.handleInputFocusExtend(e);
    }

    function handleInputKeyPress(e) {
        // Extension
        if (props.handleInputKeyPressExtend) props.handleInputKeyPressExtend(e);
    }

    function handleInputChange(e) {
        const { inputStateName, isInputValueTrim_onChange, inputMaxLength } = props;

        // Value
        const { value } = e.target;
        let value_formatted = value;
        if (isInputValueTrim_onChange) value_formatted = func_validation.getTrimmedString(value_formatted);
        
        // Max Length (Truncate)
        if (inputMaxLength) value_formatted = func_validation.getTruncatedString(value_formatted, inputMaxLength);
        
        // Custom Validator
        if (props.customValidator_onChange) value_formatted = props.customValidator_onChange(value_formatted);

        // Update state
        if (props.isValuePropagationGuarded_onChange) {
            if (props.isValuePropagationGuarded_onChange(value_formatted)) setInputValue(value_formatted);
        }
        else setInputValue(value_formatted);

        // Update parent state
        if (props.propagateValueChange) {
            if (props.isValuePropagationGuarded_onChange) {
                if (props.isValuePropagationGuarded_onChange(value_formatted)) props.propagateValueChange(inputStateName, value_formatted);
            }
            else props.propagateValueChange(inputStateName, value_formatted);
        }
        
        // Extension
        if (props.handleInputChangeExtend) props.handleInputChangeExtend(value_formatted);
    }

    function handleInputBlur(e) {
        const { inputStateName, isInputValueTrim_onBlur } = props;

        // Value
        const { value } = e.target;
        let value_formatted = value;
        if (isInputValueTrim_onBlur) value_formatted = func_validation.getTrimmedString(value_formatted);
        
        // Custom validator (on Blur)
        if (props.customValidator_onBlur) value_formatted = props.customValidator_onBlur(value_formatted);

        // Update State
        if (props.isValuePropagationGuarded_onBlur) {
            if (props.isValuePropagationGuarded_onBlur(value_formatted)) setInputValue(value_formatted);
        }
        else setInputValue(value_formatted);

        // Update parent state
        if (props.propagateValueChange) {
            if (props.isValuePropagationGuarded_onBlur) {
                if (props.isValuePropagationGuarded_onBlur(value_formatted)) props.propagateValueChange(inputStateName, value_formatted);
            }
            else props.propagateValueChange(inputStateName, value_formatted);
        }
        
        // Extension
        if (props.handleInputBlurExtend) props.handleInputBlurExtend(value_formatted);
    }

    // Label
    let inputLabelDisplay = (
        <span className="component-formInput-label">
            {inputLabel}
            {(isInputOptional)?"":(<span className="component-formInput-labelAsterisk">*</span>)}
        </span>
    );

    // SideLabel
    let inputSideLabelDisplay = (
        <span className="component-formInput-sideLabel">
            {inputSideLabel}
        </span>
    );

    // Input Type
    let customInputType_formatted = (func_validation.isStringTrimNotEmpty(customInputType)?customInputType:"text");
    
    // Error Values
    let isError = false;
    let errorMsg = "";
    
    // Error Checking (Default)
    isError = (isFormSubmissionAttempted && 
        (func_validation.isNullUndefined(inputValue) || func_validation.isStringTrimEmpty(inputValue)));
    errorMsg = (func_validation.isStringTrimNotEmpty(customErrorMsgDefault))?customErrorMsgDefault:"Input is Required";
    
    // Custom Error Checking (Empty)
    if (func_validation.isNotNullUndefined(customErrorValidation)) {
        isError = (customErrorValidation);
        errorMsg = (isError && func_validation.isStringTrimNotEmpty(customErrorMsg))?
                    customErrorMsg:errorMsg;
    }
    
    // Error Display
    let errorDisplay = (isError)?(<span className="component-formInput-errorMessage">{errorMsg}</span>):"";
    
    // Custom Error for Input
    let isInputHasError_formatted = func_validation.isBooleanTrueNotNullUndefined(isInputHasError);

    // Custom Error Display
    let customErrorDisplay = "";
    if (func_validation.isArrayNotEmpty(customErrorDisplayArray)) {
        customErrorDisplay = customErrorDisplayArray.map((customErrorDisplayItem, idx)=>{
            let isError_custom = func_validation.getObjectPropertyValue(customErrorDisplayItem, "isError", false);
            let errorMsg_custom = func_validation.getObjectPropertyValue(customErrorDisplayItem, "errorMsg", "");
            if (func_validation.isBooleanTrueNotNullUndefined(isError_custom) && 
                func_validation.isStringTrimNotEmpty(errorMsg_custom)) {
                return (<span className="component-formInput-errorMessage" key={idx}>{errorMsg_custom}</span>);
            }
        });
    }

    // Input Options
    let inputCustomOptions_formatted = (func_validation.isObjectNotEmpty(inputCustomOptions)?inputCustomOptions:{});
    
    // Input
    let inputDisplay = (
        <textarea type={customInputType_formatted} 
            className={"component-formInput-input "+
                        ((customInputClassName)?customInputClassName+" ":"")+
                        (((isError || isInputHasError_formatted) && !isErrorOptional)?"component-formInput-inputHasError ":"")} 
            name={inputName} value={inputValue} 

            onClick={(e)=>{ if (isInputClickHandlingRequired) handleInputClick(e); }}
            onFocus={(e)=>{ if (isInputFocusHandlingRequired) handleInputFocus(e); }} 
            onKeyPress={(e)=>{ if (isInputKeyPressHandlingRequired) handleInputKeyPress(e); }}
            onChange={(e)=>{ handleInputChange(e); }}
            onBlur={(e)=>{ if (isInputBlurHandlingRequired) handleInputBlur(e); }} 

            maxLength={(inputMaxLength)?inputMaxLength:524288} 
            rows={(inputRows)?inputRows:2}

            placeholder={(inputPlaceholder)?inputPlaceholder:""} 
            disabled={(isInputDisabled)} 

            {...inputCustomOptions_formatted}
        />
    );

    // Side Info within Input
    let inputDisplay_complex = ((inputDisplayLeftSide || inputDisplayRightSide)?(
        <div className={"component-formInput-inputWithSide "+
                        ((customComplexInputClassName)?customComplexInputClassName+" ":"")+
                        ((isInputSideHiddenOnFocus)?"component-formInput-inputWithSide_focusHidden ":"")+
                        ((inputDisplayLeftSide)?"component-formInput-inputWithSide_hasLeft ":"")+
                        ((inputDisplayRightSide)?"component-formInput-inputWithSide_hasRight ":"")}>

            {/* Input */}
            {inputDisplay}

            {/* Left Side */}
            {(inputDisplayLeftSide)?(
                <div className="component-formInput-inputSide_left">
                    {inputDisplayLeftSide}
                </div>
            ):""}
            
            {/* Right Side */}
            {(inputDisplayRightSide)?(
                <div className="component-formInput-inputSide_right">
                    {inputDisplayRightSide}
                </div>
            ):""}
        </div>
    ):inputDisplay);
    
    return (
        <FormInput className={""+((className)?className+" ":"")+
                                    ((formInputCustomTheme)?formInputCustomTheme+" ":"component-formInputTheme_default ")} 
            isMarginBtmOptional={isMarginBtmOptional}>
            
            <div className={"component-formInputTextArea " + 
                    (wrapperClassname? wrapperClassname + " ":"")}
            >

                {/* Label */}
                {(isLabelOptional)?"":(
                    <div className="component-formInput-labelGroup d-flex align-items-center justify-content-between">
                        {inputLabelDisplay}
                        {inputSideLabel? inputSideLabelDisplay:""}
                    </div>
                )}
                
                {/* Input */}
                {(isInputGrouped)?(
                    <div className="component-formInput-group d-flex align-items-center">
                        {/* Prepend */}
                        {(inputPrepend)?(
                            <div className={"component-formInput-prepend "+
                                            ((customPrependClassName)?customPrependClassName+" ":"")}>
                                {inputPrepend}
                            </div>
                        ):""}

                        {/* Input */}
                        {inputDisplay_complex}

                        {/* Append */}
                        {(inputAppend)?(
                            <div className={"component-formInput-append "+
                                            ((customAppendClassName)?customAppendClassName+" ":"")}>
                                {inputAppend}
                            </div>
                        ):""}
                    </div>
                ):inputDisplay_complex}
                
                {/* Error Message */}
                {(isErrorMsgOptional)?"":(errorDisplay)}
                
                {/* Custom Error Message */}
                {(customErrorDisplay)?customErrorDisplay:""}
            
            </div>
        </FormInput>
    );
}



const FormInput_textarea = FormInput_textareaPresentation;
export { FormInput_textarea };